import { buildPaginationQuery } from "@/helpers/request-helpers";
import ISalesProduct from "@/interfaces/sales-product.interfaces";
import { apiBackofficeT2b } from "@/lib/axios";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class SalesProductService {
  private async getAccessToken(): Promise<string> {
    const email: string = import.meta.env.VITE_INTERNAL_USER_EMAIL || "";
    const password: string = import.meta.env.VITE_INTERNAL_USER_PASSWORD || "";

    const response = await apiBackofficeT2b.post("/v1/login", {
      login: email,
      password: password,
    });

    return response.data.accessToken;
  }

  async getAllSalesProducts(
    filter: IFilter<ISalesProduct>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ISalesProduct>> {
    const accessToken = await this.getAccessToken();
    const paginationQuery = buildPaginationQuery(pagination);

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Se não há filtros, usa GET
    if (!filter || filter.length === 0) {
      const response = await apiBackofficeT2b.get(`v1/salesproduct?${paginationQuery}`, config);

      const paginatedResponse = {
        items: response.data.items,
        totalCount: response.data.totalCount,
        pageNumber: pagination.pageNumber,
        pageSize: pagination.pageSize,
        hasNextPage: response.data.hasNextPage,
        hasPreviousPage: response.data.hasPreviousPage,
      };

      return paginatedResponse;
    }

    // Se há filtros, usa POST
    const response = await apiBackofficeT2b.post(
      `v1/salesproduct/filter?${paginationQuery}`,
      {
        filter,
      },
      {
        ...config,
        headers: {
          ...config.headers,
          "Content-Type": "application/json",
        },
      }
    );

    const paginatedResponse = {
      items: response.data.items,
      totalCount: response.data.totalCount,
      pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
      hasNextPage: response.data.hasNextPage,
      hasPreviousPage: response.data.hasPreviousPage,
    };

    return paginatedResponse;
  }

  async getById(salesProductId: number): Promise<ISalesProduct> {
    const accessToken = await this.getAccessToken();
    const response = await apiBackofficeT2b.get(`/v1/salesproduct/${salesProductId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const salesProduct = response.data;
    return salesProduct;
  }
}

const salesProductService = new SalesProductService();
export default salesProductService;
